import Vue from 'vue';
import Router from 'vue-router';
import Home from './pages/Home/Home';

Vue.use(Router);

const siteName = '- My Little Pony Collection';

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true,
      meta: {
        title: `Home${siteName}`
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/About/About'),
      meta: {
        title: `About ${siteName}`
      }
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      // route level code-splitting
      // this generates a separate chunk (disclaimer.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "disclaimer" */ './pages/Disclaimer/Disclaimer'),
      meta: {
        title: `Disclaimer ${siteName}`
      }
    },
    {
      path: '/contact',
      name: 'contact',
      // route level code-splitting
      // this generates a separate chunk (contact.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "contact" */ './pages/Contact/Contact'),
      meta: {
        title: `Contact ${siteName}`
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "faq" */ './pages/Faq/Faq'),
      props: true,
      meta: {
        title: `FAQ ${siteName}`
      }
    },
    {
      path: '/pony-search',
      name: 'pony-search',
      component: () =>
        import(/* webpackChunkName: "pony-search" */ './pages/PonySearch/PonySearch'),
      props: true,
      meta: {
        title: `Search Ponies ${siteName}`
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () =>
        import(/* webpackChunkName: "privacy" */ './pages/Privacy/Privacy'),
      props: true,
      meta: {
        title: `Privacy ${siteName}`
      }
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: () =>
        import(/* webpackChunkName: "terms-of-service" */ './pages/TermsOfService/TermsOfService'),
      props: true,
      meta: {
        title: `Terms of Service ${siteName}`
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './pages/Login/Login'),
      props: true,
      meta: {
        title: `Login ${siteName}`
      }
    },
    {
      path: '/accessory/create/',
      name: 'accessory-create',
      component: () =>
        import(/* webpackChunkName: "accessoryCreate" */ './pages/AccessoryCreate/AccessoryCreate'),
      props: true,
      meta: {
        title: `Add an Accessory ${siteName}`
      }
    },
    {
      path: '/accessory/:slug/edit',
      name: 'accessory-edit',
      component: () =>
        import(/* webpackChunkName: "accessoryEdit" */ './pages/AccessoryEdit/AccessoryEdit'),
      props: true,
      meta: {
        title: `Edit Accessory ${siteName}`
      }
    },
    {
      path: '/accessory/:slug',
      name: 'accessory',
      component: () =>
        import(/* webpackChunkName: "accessory" */ './pages/Accessory/Accessory'),
      props: true,
      meta: {
        title: `Accessory ${siteName}`
      }
    },
    {
      path: '/accessories',
      name: 'accessory-list',
      component: () =>
        import(/* webpackChunkName: "accessoryList" */ './pages/AccessoryList/AccessoryList'),
      props: true,
      meta: {
        title: `Accessories ${siteName}`
      }
    },
    {
      path: '/brand/create/',
      name: 'brand-create',
      component: () =>
        import(/* webpackChunkName: "brandCreate" */ './pages/BrandCreate/BrandCreate'),
      props: true,
      meta: {
        title: `Add a Brand ${siteName}`
      }
    },
    {
      path: '/brand/:slug/edit',
      name: 'brand-edit',
      component: () =>
        import(/* webpackChunkName: "brandEdit" */ './pages/BrandEdit/BrandEdit'),
      props: true,
      meta: {
        title: `Edit Brand ${siteName}`
      }
    },
    {
      path: '/brand/:slug',
      name: 'brand',
      component: () =>
        import(/* webpackChunkName: "brand" */ './pages/Brand/Brand'),
      props: true,
      meta: {
        title: `Brand ${siteName}`
      }
    },
    {
      path: '/brands',
      name: 'brand-list',
      component: () =>
        import(/* webpackChunkName: "brandList" */ './pages/BrandList/BrandList'),
      props: true,
      meta: {
        title: `Brands ${siteName}`
      }
    },
    {
      path: '/body-color/create/',
      name: 'body-color-create',
      component: () =>
        import(/* webpackChunkName: "bodyColorCreate" */ './pages/BodyColorCreate/BodyColorCreate'),
      props: true,
      meta: {
        title: `Add a Color ${siteName}`
      }
    },
    {
      path: '/body-color/:slug/edit',
      name: 'body-color-edit',
      component: () =>
        import(/* webpackChunkName: "bodyColorEdit" */ './pages/BodyColorEdit/BodyColorEdit'),
      props: true,
      meta: {
        title: `Edit Color ${siteName}`
      }
    },
    {
      path: '/body-color/:slug',
      name: 'body-color',
      component: () =>
        import(/* webpackChunkName: "bodyColor" */ './pages/BodyColor/BodyColor'),
      props: true,
      meta: {
        title: `Color ${siteName}`
      }
    },
    {
      path: '/body-colors',
      name: 'body-color-list',
      component: () =>
        import(/* webpackChunkName: "bodyColorList" */ './pages/BodyColorList/BodyColorList'),
      props: true,
      meta: {
        title: `Colors ${siteName}`
      }
    },
    {
      path: '/character/create/',
      name: 'character-create',
      component: () =>
        import(/* webpackChunkName: "characterCreate" */ './pages/CharacterCreate/CharacterCreate'),
      props: true,
      meta: {
        title: `New Character ${siteName}`
      }
    },
    {
      path: '/character/:slug/edit',
      name: 'character-edit',
      component: () =>
        import(/* webpackChunkName: "characterEdit" */ './pages/CharacterEdit/CharacterEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/character/:slug',
      name: 'character',
      component: () =>
        import(/* webpackChunkName: "character" */ './pages/Character/Character'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/characters',
      name: 'character-list',
      component: () =>
        import(/* webpackChunkName: "characterList" */ './pages/CharacterList/CharacterList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/comment/:id/edit',
      name: 'comment-edit',
      component: () =>
        import(/* webpackChunkName: "commentEdit" */ './pages/CommentEdit/CommentEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/comment/:id',
      name: 'comment',
      component: () =>
        import(/* webpackChunkName: "comment" */ './pages/Comment/Comment'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/comments',
      name: 'comment-list',
      component: () =>
        import(/* webpackChunkName: "commentList" */ './pages/CommentList/CommentList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/country/create/',
      name: 'country-create',
      component: () =>
        import(/* webpackChunkName: "countryCreate" */ './pages/CountryCreate/CountryCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/country/:slug/edit',
      name: 'country-edit',
      component: () =>
        import(/* webpackChunkName: "countryEdit" */ './pages/CountryEdit/CountryEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/country/:slug',
      name: 'country',
      component: () =>
        import(/* webpackChunkName: "country" */ './pages/Country/Country'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/countries',
      name: 'country-list',
      component: () =>
        import(/* webpackChunkName: "countryList" */ './pages/CountryList/CountryList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/items',
      name: 'favorite-items-list',
      component: () =>
        import(/* webpackChunkName: "favoriteItems" */ './pages/FavoriteItemList/FavoriteItemList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/favorite/:username',
      name: 'favorite',
      component: () =>
        import(/* webpackChunkName: "favorites" */ './pages/Favorites/Favorites'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/favorites',
      name: 'favorites',
      component: () =>
        import(/* webpackChunkName: "favoritesList" */ './pages/FavoritesList/FavoritesList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/flag/:id/edit',
      name: 'flag-edit',
      component: () =>
        import(/* webpackChunkName: "flagEdit" */ './pages/FlagEdit/FlagEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/flag/:id',
      name: 'flag',
      component: () =>
        import(/* webpackChunkName: "flag" */ './pages/Flag/Flag'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/flags',
      name: 'flag-list',
      component: () =>
        import(/* webpackChunkName: "flagList" */ './pages/FlagList/FlagList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/generation/create/',
      name: 'generation-create',
      component: () =>
        import(/* webpackChunkName: "generationCreate" */ './pages/GenerationCreate/GenerationCreate'),
      props: true,
      meta: {
        title: `Create Generation ${siteName}`
      }
    },
    {
      path: '/generation/:slug/edit',
      name: 'generation-edit',
      component: () =>
        import(/* webpackChunkName: "generationEdit" */ './pages/GenerationEdit/GenerationEdit'),
      props: true,
      meta: {
        title: `Edit Generation ${siteName}`
      }
    },
    {
      path: '/generation/:slug',
      name: 'generation',
      component: () =>
        import(/* webpackChunkName: "generation" */ './pages/Generation/Generation'),
      props: true,
      meta: {
        title: `Generation ${siteName}`
      }
    },
    {
      path: '/generations',
      name: 'generation-list',
      component: () =>
        import(/* webpackChunkName: "generationList" */ './pages/GenerationList/GenerationList'),
      props: true,
      meta: {
        title: `Generations ${siteName}`
      }
    },
    {
      path: '/grouping/create/',
      name: 'grouping-create',
      component: () =>
        import(/* webpackChunkName: "groupingCreate" */ './pages/GroupingCreate/GroupingCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/grouping/:slug/edit',
      name: 'grouping-edit',
      component: () =>
        import(/* webpackChunkName: "groupingEdit" */ './pages/GroupingEdit/GroupingEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/grouping/:slug/related',
      name: 'groupings-related',
      component: () =>
        import(/* webpackChunkName: "groupingsRelated" */ './pages/GroupingsRelated/GroupingsRelated'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/grouping/:slug/pony/create',
      name: 'pony-create',
      component: () =>
        import(/* webpackChunkName: "pony-create" */ './pages/PonyCreate/PonyCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/grouping/:slug',
      name: 'grouping',
      component: () =>
        import(/* webpackChunkName: "grouping" */ './pages/Grouping/Grouping'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/groupings',
      name: 'grouping-list',
      component: () =>
        import(/* webpackChunkName: "groupingList" */ './pages/GroupingList/GroupingList'),
      props: true,
      meta: {
        title: `Groups ${siteName}`
      }
    },
    {
      path: '/hair-color/create/',
      name: 'hair-color-create',
      component: () =>
        import(/* webpackChunkName: "hairColorCreate" */ './pages/HairColorCreate/HairColorCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/hair-color/:Slug/edit',
      name: 'hair-color-edit',
      component: () =>
        import(/* webpackChunkName: "hairColorEdit" */ './pages/HairColorEdit/HairColorEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/hair-color/:Slug',
      name: 'hair-color',
      component: () =>
        import(/* webpackChunkName: "hairColor" */ './pages/HairColor/HairColor'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/hair-colors',
      name: 'hair-color-list',
      component: () =>
        import(/* webpackChunkName: "hairColorList" */ './pages/HairColorList/HairColorList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/herd-item/:id/edit',
      name: 'herd-item-edit',
      component: () =>
        import(/* webpackChunkName: "herdItemEdit" */ './pages/HerdItemEdit/HerdItemEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/herd-item/:id',
      name: 'herd-item',
      component: () =>
        import(/* webpackChunkName: "herdItem" */ './pages/HerdItem/HerdItem'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/herd/:id/edit',
      name: 'herd-edit',
      component: () =>
        import(/* webpackChunkName: "herdEdit" */ './pages/HerdEdit/HerdEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/herd/:id',
      name: 'herd',
      component: () =>
        import(/* webpackChunkName: "herd" */ './pages/Herd/Herd'),
      props: true,
      meta: {
        title: `Herd ${siteName}`
      }
    },
    {
      path: '/herds',
      name: 'herds',
      component: () =>
        import(/* webpackChunkName: "herdList" */ './pages/HerdList/HerdList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/image/:id/edit',
      name: 'image-edit',
      component: () =>
        import(/* webpackChunkName: "imageEdit" */ './pages/ImageEdit/ImageEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/image/:id',
      name: 'image',
      component: () =>
        import(/* webpackChunkName: "image" */ './pages/Image/Image'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/images',
      name: 'image-list',
      component: () =>
        import(/* webpackChunkName: "imageList" */ './pages/ImageList/ImageList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/inquiry/create/',
      name: 'inquiry-create',
      component: () =>
        import(/* webpackChunkName: "inquiryCreate" */ './pages/InquiryCreate/InquiryCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/inquiry/:id/edit',
      name: 'inquiry-edit',
      component: () =>
        import(/* webpackChunkName: "inquiryEdit" */ './pages/InquiryEdit/InquiryEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/inquiry/:id',
      name: 'inquiry',
      component: () =>
        import(/* webpackChunkName: "inquiry" */ './pages/Inquiry/Inquiry'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/inquiries',
      name: 'inquiry-list',
      component: () =>
        import(/* webpackChunkName: "inquiryList" */ './pages/InquiryList/InquiryList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/manufacturer/create/',
      name: 'manufacturer-create',
      component: () =>
        import(/* webpackChunkName: "manufacturerCreate" */ './pages/ManufacturerCreate/ManufacturerCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/manufacturer/:slug/edit',
      name: 'manufacturer-edit',
      component: () =>
        import(/* webpackChunkName: "manufacturerEdit" */ './pages/ManufacturerEdit/ManufacturerEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/manufacturer/:slug',
      name: 'manufacturer',
      component: () =>
        import(/* webpackChunkName: "manufacturer" */ './pages/Manufacturer/Manufacturer'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/manufacturers',
      name: 'manufacturer-list',
      component: () =>
        import(/* webpackChunkName: "manufacturerList" */ './pages/ManufacturerList/ManufacturerList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/mold/create/',
      name: 'mold-create',
      component: () =>
        import(/* webpackChunkName: "moldCreate" */ './pages/MoldCreate/MoldCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/mold/:slug/edit',
      name: 'mold-edit',
      component: () =>
        import(/* webpackChunkName: "moldEdit" */ './pages/MoldEdit/MoldEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/mold/:slug',
      name: 'mold',
      component: () =>
        import(/* webpackChunkName: "mold" */ './pages/Mold/Mold'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/molds',
      name: 'mold-list',
      component: () =>
        import(/* webpackChunkName: "moldList" */ './pages/MoldList/MoldList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/origin/create/',
      name: 'origin-create',
      component: () =>
        import(/* webpackChunkName: "originCreate" */ './pages/OriginCreate/OriginCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/origin/:slug/edit',
      name: 'origin-edit',
      component: () =>
        import(/* webpackChunkName: "originEdit" */ './pages/OriginEdit/OriginEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/origin/:slug',
      name: 'origin',
      component: () =>
        import(/* webpackChunkName: "origin" */ './pages/Origin/Origin'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/origins',
      name: 'origin-list',
      component: () =>
        import(/* webpackChunkName: "originList" */ './pages/OriginList/OriginList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/pony/:slug/edit',
      name: 'pony-edit',
      component: () =>
        import(/* webpackChunkName: "ponyEdit" */ './pages/PonyEdit/PonyEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/pony/:slug',
      name: 'pony',
      component: () =>
        import(/* webpackChunkName: "pony" */ './pages/Pony/Pony'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/ponies',
      name: 'pony-list',
      component: () =>
        import(/* webpackChunkName: "ponyList" */ './pages/PonyList/PonyList'),
      props: true,
      meta: {
        title: `Pony Filter ${siteName}`
      }
    },
    {
      path: '/pose/create/',
      name: 'pose-create',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/PoseCreate/PoseCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/pose/:slug/edit',
      name: 'pose-edit',
      component: () =>
        import(/* webpackChunkName: "poseEdit" */ './pages/PoseEdit/PoseEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/pose/:slug',
      name: 'pose',
      component: () =>
        import(/* webpackChunkName: "pose" */ './pages/Pose/Pose'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/poses',
      name: 'pose-list',
      component: () =>
        import(/* webpackChunkName: "poseList" */ './pages/PoseList/PoseList'),
      props: true,
      meta: {
        title: `Poses ${siteName}`
      }
    },
    {
      path: '/question/create/',
      name: 'question-create',
      component: () =>
        import(/* webpackChunkName: "questionCreate" */ './pages/QuestionCreate/QuestionCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/question/:id/edit',
      name: 'question-edit',
      component: () =>
        import(/* webpackChunkName: "questionEdit" */ './pages/QuestionEdit/QuestionEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/question/:id',
      name: 'question',
      component: () =>
        import(/* webpackChunkName: "question" */ './pages/Question/Question'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/questions',
      name: 'question-list',
      component: () =>
        import(/* webpackChunkName: "questionList" */ './pages/QuestionList/QuestionList'),
      props: true,
      meta: {
        title: `Questions ${siteName}`
      }
    },
    {
      path: '/release/create/',
      name: 'release-create',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/ReleaseCreate/ReleaseCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/release/:slug/edit',
      name: 'release-edit',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/ReleaseEdit/ReleaseEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/release/:slug',
      name: 'release',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/Release/Release'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/releases',
      name: 'release-list',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/ReleaseList/ReleaseList'),
      props: true,
      meta: {
        title: `Releases ${siteName}`
      }
    },
    {
      path: '/theme/create/',
      name: 'theme-create',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/ThemeCreate/ThemeCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/theme/:slug/edit',
      name: 'theme-edit',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/ThemeEdit/ThemeEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/theme/:slug',
      name: 'theme',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/Theme/Theme'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/themes',
      name: 'theme-list',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/ThemeList/ThemeList'),
      props: true,
      meta: {
        title: `Themes ${siteName}`
      }
    },
    {
      path: '/wishlist-item/:ponyId/edit',
      name: 'wishlist-item-edit',
      component: () =>
        import(/* webpackChunkName: "wishlistItemEdit" */ './pages/WishlistItemEdit/WishlistItemEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/wishlist-item/:ponyId',
      name: 'wishlist-item',
      component: () =>
        import(/* webpackChunkName: "wishlistItem" */ './pages/WishlistItem/WishlistItem'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/wishlist/:id',
      name: 'wishlist',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/Wishlist/Wishlist'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/wishlists',
      name: 'wishlists',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/WishlistList/WishlistList'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/year/create/',
      name: 'year-create',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/YearCreate/YearCreate'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/year/:slug/edit',
      name: 'year-edit',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/YearEdit/YearEdit'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/year/:slug',
      name: 'year',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/Year/Year'),
      props: true,
      meta: {
        title: ` ${siteName}`
      }
    },
    {
      path: '/years',
      name: 'year-list',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/YearList/YearList'),
      props: true,
      meta: {
        title: `Years ${siteName}`
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () =>
        import(/* webpackChunkName: "Dashboard" */ './pages/Dashboard/Dashboard'),
      props: true,
      meta: {
        title: `Dashboard ${siteName}`
      }
    },
    {
      path: '/user/:id',
      name: 'user',
      component: () =>
        import(/* webpackChunkName: "User" */ './pages/User/User'),
      props: true,
      meta: {
        title: `User ${siteName}`
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () =>
        import(/* webpackChunkName: "Register" */ './pages/Register/Register'),
      props: true,
      meta: {
        title: `Register ${siteName}`
      }
    },
    {
      path: '/list/:category/:value/ponies',
      name: 'category',
      component: () =>
        import(/* webpackChunkName: "Category" */ './pages/Category/Category'),
      props: true,
      meta: {
        title: `Category ${siteName}`
      }
    },
    {
      path: '/list/:category',
      name: 'category-list',
      component: () =>
        import(/* webpackChunkName: "CategoryList" */ './pages/CategoryList/CategoryList'),
      props: true,
      meta: {
        title: `Category List ${siteName}`
      }
    },
    {
      path: '/admin-dashboard',
      name: 'admin-dashboard',
      component: () =>
        import(/* webpackChunkName: "DashboardAdmin" */ './pages/DashboardAdmin/DashboardAdmin'),
      props: true,
      meta: {
        title: `Administrator Dashboard ${siteName}`
      }
    },
    {
      path: '/categories',
      name: 'categories',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/Categories/Categories'),
      props: true,
      meta: {
        title: `Category List ${siteName}`
      }
    },
    {
      path: '*',
      component: () =>
        import(/* webpackChunkName: "about" */ './pages/FourOhFour/FourOhFour'),
      meta: {
        title: `404 ${siteName}`
      }
    }
  ]
});
